export const Modal = {
  namespaced: true,
  state: {
    isFixed: false
  },
  getters: {
    isFixed: (state) => state.isFixed
  },
  mutations: {
    UPDATE_IS_FIXED (state, payload) {
      state.isFixed = payload
    }
  },
  actions: {
    /**
     * 画面スクロールを固定する
     * @param {object} commit
     * @param {Bool} isFixed
     */
    action_ToggleModal ({ commit }, isFixed) {
      commit('UPDATE_IS_FIXED', isFixed)
    }
  }
}
